/**
 * Solar buyback display. Per AIOpCo Docs & Templates/Solar Credit Plan Research.md (Serena-CSO, 2026-09-23):
 * a plan is tagged solar-eligible only when the server has a real export-credit rate/structure to show, not
 * just a boolean with nothing behind it. Contract with Torvalds-BE (backend/catalog/models.py,
 * SOLAR_BUYBACK_RATE_TYPES):
 *   - plan.solar_buyback: boolean
 *   - plan.solar_buyback_rate_type: "fixed" | "retail_rate_match" | "real_time_wholesale"
 *   - plan.solar_buyback_rate: number (cents/kWh) — present when rate_type is "fixed"
 * Query param on GET /api/plans: solar_buyback=true (backend/catalog/router.py).
 */
export function formatSolarBuyback(plan) {
  if (!plan || !plan.solar_buyback) return null;
  const type = plan.solar_buyback_rate_type;
  if (type === "fixed" && Number.isFinite(plan.solar_buyback_rate)) {
    return `Solar buyback: ${plan.solar_buyback_rate.toFixed(1)}¢/kWh fixed`;
  }
  if (type === "retail_rate_match") return "Solar buyback: retail-rate match";
  if (type === "real_time_wholesale") return "Solar buyback: real-time wholesale rate";
  return "Solar buyback available";
}
